import { useRouteRef } from '@backstage/core-plugin-api';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { frontierRootRouteRef } from '../routes';
import { ControlPlaneConnectPage } from './ControlPlaneConnectPage';
import { ControlPlaneCreationPage } from './ControlPlaneCreationPage';
import { ControlPlaneActivityCockpitPage } from '../cockpit/ControlPlaneActivityCockpitPage';

const CockpitRoute = () => {
  const { activityId = '' } = useParams();
  return <ControlPlaneActivityCockpitPage activityId={activityId} />;
};

const FrontierPortfolioRedirect = () => {
  const frontierRoot = useRouteRef(frontierRootRouteRef);
  return <Navigate to={frontierRoot()} replace />;
};

export const ControlPlanePage = () => {
  return (
    <Routes>
      <Route path="new" element={<ControlPlaneCreationPage />} />
      <Route
        path="activities/:activityId/connect"
        element={<ControlPlaneConnectPage />}
      />
      <Route path="activities/:activityId/cockpit" element={<CockpitRoute />} />
      <Route path="*" element={<FrontierPortfolioRedirect />} />
    </Routes>
  );
};
